module.exports = "/assets/dist/images/convertible_wide.jpg?6f666763f1a0ec51f3ecdc14a49b38be";